import { makeAutoObservable } from 'mobx';
import { GroupsApi } from '../../api/GroupApi';
import { AccountMappings } from '../models/AccountMappings';
import { Group } from '../models/Group';

export class AccountMappingsStore {
  groupMappings: Map<number, AccountMappings> = new Map();

  constructor() {
    makeAutoObservable(this);
  }

  load = (group: Group) => {
    if (this.groupMappings.has(group.id)) {
      return Promise.resolve(this.groupMappings.get(group.id));
    }

    return GroupsApi.getAccountMappings(group.id)
      .then(data => {
        const mappings = AccountMappings.fromApi(group, data);
        this.groupMappings.set(group.id, mappings);
        return mappings;
      });
  };

  getGroupMappings = (groupId: number) => this.groupMappings.get(groupId);

}
